import BaseApiService from '../baseApi.service';

export default class MemberShipPointsService extends BaseApiService {
  readonly basePath: string = 'memberships/v1';
  constructor(props = null) {
    super(props);
  }
}
